import Vue from 'vue';
export function showMoreFn() {
    const shoMoreContent = document.querySelectorAll('.image_text_show_more_section');
    (function () {
        if (!shoMoreContent || !shoMoreContent.length) {
            return false
        }
    })()
    let ids = [...shoMoreContent].map(el => el.id)
    if (ids && ids.length) {
        ids.forEach(el => {
            new Vue({
                el: `#${el}`,
                data() {
                    return {
                        showMore: false,
                    }
                },
                watch: {
                    showMore(v) {
                        if(!v && window.innerWidth < 1024) {
                            const headerHeight = document.getElementById('Header').clientHeight
                            const scrollDiv = document.getElementById(el).offsetTop
                            if(!headerHeight || !scrollDiv) return
                            window.scrollTo({ top: scrollDiv - headerHeight, behavior: 'smooth'})
                        }
                    }
                }
            })
        })
    }
}
showMoreFn()